// extracted by mini-css-extract-plugin
export default {"indices-container":"Bv5iJD6Kf6DZsajcP2mG","exchange-name":"tbwJ4BsKEwFJrrBeZ39q","today-quote-price":"BYhxfohiZsa8zlL0IVnY"};